import React from "react";
import { useTranslation } from "react-i18next";
import PublicHeader from "@/components/layout/PublicHeader";
import PublicFooter from "@/components/layout/PublicFooter";
import { ShieldCheck, Ship, ClipboardCheck, Truck, PackageCheck, Users, Warehouse, FileText } from "lucide-react";

const ICONS = [ClipboardCheck, ShieldCheck, Ship, Warehouse, Truck, FileText, PackageCheck, Users];

export default function Services() {
  const { t } = useTranslation();
  const items = t("svc.items", { returnObjects: true });
  return (
    <div data-testid="services-page" className="min-h-screen bg-background">
      <PublicHeader />
      <section className="max-w-7xl mx-auto px-6 lg:px-10 py-20">
        <div className="max-w-3xl">
          <div className="overline text-primary mb-4">{t("svc.eyebrow")}</div>
          <h1 className="font-heading text-5xl md:text-6xl font-black tracking-tighter text-secondary leading-none">
            {t("svc.h")}
          </h1>
          <p className="mt-6 text-lg text-muted-foreground leading-relaxed">{t("svc.sub")}</p>
        </div>
        <div className="mt-16 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-6">
          {Array.isArray(items) &&
            items.map((s, i) => {
              const Icon = ICONS[i] || ClipboardCheck;
              return (
                <div key={s.t} data-testid={`svc-item-${i}`} className="bg-white border border-border rounded-lg p-8 card-lift">
                  <Icon className="w-8 h-8 text-primary mb-6" />
                  <h3 className="font-heading text-xl font-bold tracking-tight text-secondary">{s.t}</h3>
                  <p className="mt-2 text-sm text-muted-foreground leading-relaxed">{s.d}</p>
                </div>
              );
            })}
        </div>
      </section>
      <PublicFooter />
    </div>
  );
}
